'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScript = exports.post = exports.get = exports.requestIsSucc = exports.defaultFormatResult = exports.defaultFormatParams = undefined;

var _cache = require('./cache');

var _cache2 = _interopRequireDefault(_cache);

var _merge = require('./merge');

var _merge2 = _interopRequireDefault(_merge);

var _download = require('./download');

var _download2 = _interopRequireDefault(_download);

var _util = require('./util');

var _loading = require('./loading/loading');

var _loading2 = _interopRequireDefault(_loading);

var _config = require('@config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// method常量定义
/**
 * model请求基础方法
 * Created by spring on 2018/9/22.
 */

// import { ERROR_MSG, validate } from './validate';
var METHOD_GET = 'GET';
var METHOD_POST = 'POST';

var DATA_TYPE_JSON = 'json';
var DATA_TYPE_JSONP = 'jsonp';
var DATA_TYPE_SCRIPT = 'script';
// const DATA_TYPE_TEXT = 'text';

// const ERROR_MESSAGE = 'error';
// const SUCCESS_MESSAGE = 'success';

/**
 * 显示全局的提示消息
 * @param type 消息类型，成功或者错误
 * @param message 消息文本
 */
// const showMessage = (type, message, title = '') => {
//   console.log('request message', type, message, title);
// };

// /**
//  * 设置apiBase字段
//  * @param apiBase 一般是在config里面配置的，随环境改变而改变
//  */
// export const setApiBase = (apiBase) => {
//   cache.set('miHoYoApiBase', apiBase);
// };

/**
 * 格式化请求参数,根据不同接口自行处理
 * @param params 键值对对象,形如 {}
 * @returns {*} 格式化后的参数
 */
var defaultFormatParams = exports.defaultFormatParams = function defaultFormatParams(params) {
  return params;
};

/**
 * 格式化返回结果,根据不同接口自行处理
 * @param data 对象 数组等任意合法的JS数据类型
 * @returns {*} 格式化后的数据
 */
var defaultFormatResult = exports.defaultFormatResult = function defaultFormatResult(data) {
  return data;
};

/**
 * 请求成功判断
 * @param rsp 原生返回的请求对象
 * @returns {boolean|*}
 */
var requestIsSucc = exports.requestIsSucc = function requestIsSucc(rsp) {
  return rsp && rsp.retcode === 0;
};

var i = 0;

/**
 * 请求发送
 * @param method 请求类型
 * @param url 请求地址（这里会自动和apiBase前缀组合）
 * @param options 请求参数对象，可以直接是数据对象 如{param1：1}，也可以增加一层控制参数{isShowloading: false, data:{param1：1}}
 * @param fmtParams 参数格式化方法
 * @param formatResult 返回数据格式化方法
 * @returns {Promise} promise对象
 */
var request = function request(method, url, options, fmtParams, fmtResult) {
  var deferr = $.Deferred();

  var ajaxUrl = /^http/i.test(url) ? url : _config.apiBase + url;

  var args = $.extend({
    loading: true,
    type: METHOD_GET,
    dataType: DATA_TYPE_JSON,
    xhrFields: {
      withCredentials: true
    }
  }, options, {
    url: ajaxUrl,
    type: method
  });

  // const method = args.type;
  // const { url } = args;
  var params = fmtParams(args.data);

  // 书否存在验证配置对象，具体格式参考vue的props的配置方式
  // if (args.validator) {
  //   const validResult = validate(args.data, args.validator);
  //
  //   // retcode 非0 标识验证不通过，展示错误信息
  //   if (validResult.retcode !== 0) {
  //     // showMessage(
  //     //   ERROR_MESSAGE,
  //     //   `[ ${validResult.invalidParam.name} ] ${ERROR_MSG[validResult.retcode]}`,
  //     //   '参数错误'
  //     // );
  //     console.error(args.data);
  //     return deferr.reject(validResult);
  //   }
  //
  //   delete args.validator;
  // }

  if (args.download) {
    (0, _download2.default)((0, _util.toUrlWithParams)(ajaxUrl, params));
    return deferr.resolve({ retcode: 0 });
  }

  // 针对get请求，判断是否使用缓存，目前是内存缓存，刷新页面失效
  if (method === METHOD_GET && args.cache) {
    var cacheResult = _cache2.default.get(url, params);

    if (cacheResult) {
      return cacheResult.then(function (data) {
        return fmtResult(data);
      });
    }
  }

  // 同一个接口同时多个请求直接合并后面的请求，等待第一个请求返回后，直接返回
  if (method === METHOD_GET && args.dataType !== DATA_TYPE_SCRIPT) {
    console.log('request merge', i += 1);
    // 相同请求合并
    var resultMerge = _merge2.default.merge(url, params);

    // 此请求已合并，返回一个promise对象
    if (resultMerge) {
      return resultMerge.then(function (data) {
        return fmtResult(data);
      });
    }
  }

  if (args.loading !== false) {
    _loading2.default.show();
  }
  console.log('request merge x', i);

  // 返回Deferred
  return $.Deferred(function (defer) {
    console.log('request merge y', i);

    $.extend(args, {
      success: function success(rsp) {
        if (args.loading !== false) {
          _loading2.default.hide();
        }
        console.log(url, 'success', rsp);

        if (args.dataType === DATA_TYPE_SCRIPT) {
          defer.resolve(rsp);
        } else if (requestIsSucc(rsp)) {
          // 不破坏返回的数据，直接copy一份，对于合并的请求，model需要原始数据，如果穿对象会被改变
          var fmtData = fmtResult(args.dataType === DATA_TYPE_JSON || args.dataType === DATA_TYPE_JSONP ? JSON.parse(JSON.stringify(rsp.data)) : rsp.data);

          // get 请求默认缓存数据，然后触发合并请求的返回
          if (method === METHOD_GET) {
            _cache2.default.set(url, params, rsp.data);
            _merge2.default.remove(url, params, true, rsp.data);
          }
          defer.resolve(fmtData);
        } else {
          if (method === METHOD_GET) {
            _merge2.default.remove(url, params, false, rsp);
          }
          defer.reject(rsp);
        }
      },
      error: function error(xhr, status, err) {
        if (args.loading !== false) {
          _loading2.default.hide();
        }
        defer.catch = defer.fail;
        console.log(url, 'error', xhr.status, err);
        defer.reject({ status: xhr.status, error: err }); // error 在httpService里面已经是Promise对象了，这里不做处理
      }
    });

    // 自动打开url地址上的参数
    args.url = args.url + (args.url.indexOf('?') > -1 ? '&' : '?') + window.location.search.replace('?', '');

    $.ajax(args);
  });
};

/**
 * GET请求发送
 * @param url 请求地址（这里会自动和apiBase前缀组合）
 * @param options 请求参数对象
 * @param fmtParams 参数格式化方法
 * @param formatResult 返回数据格式化方法
 * @returns {Promise} promise对象
 */
var get = exports.get = function get() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fmtParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFormatParams;
  var fmtResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultFormatResult;
  return request(METHOD_GET, url, options, fmtParams, fmtResult);
};

/**
 * POST请求发送
 * @param url 请求地址（这里会自动和apiBase前缀组合）
 * @param options 请求参数对象
 * @param fmtParams 参数格式化方法
 * @param formatResult 返回数据格式化方法
 * @returns {Promise} promise对象
 */
var post = exports.post = function post() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fmtParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFormatParams;
  var fmtResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultFormatResult;
  return request(METHOD_POST, url, options, fmtParams, fmtResult);
};

/**
 * DELETE请求发送
 * @param url 请求地址（这里会自动和apiBase前缀组合）
 * @param options 请求参数对象
 * @param fmtParams 参数格式化方法
 * @param formatResult 返回数据格式化方法
 * @returns {Promise} promise对象
 */
var getScript = exports.getScript = function getScript() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fmtParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFormatParams;
  var fmtResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultFormatResult;
  return request(METHOD_GET, url, $.extend(options, { dataType: DATA_TYPE_SCRIPT }), fmtParams, fmtResult);
};

exports.default = {
  defaultFormatParams: defaultFormatParams,
  defaultFormatResult: defaultFormatResult,
  get: get,
  post: post,
  getScript: getScript
};